import { TextField } from '@mui/material';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
// import TextBoxWithSendButton from '../../../../components/TextBoxWithSendButton';
import DownloadFileContainer from '../../../../components/DownloadFileContainer';
import Header from '../../../../components/Header';
// import TickIcon from '../../../../svg/TickIcon';

export default function StudentSolutionDetails({ title, onBack, studentDetail }) {
  const { name } = studentDetail;
  const [assignMark, setMark] = useState('');
  // const [isMarked, setMarked] = useState(false);
  return (
    <>
      <Header title={title} onBack={onBack} subTitle={name} />
      <DownloadFileContainer title="Solution Class Test.pdf" />
      <TextField
        fullWidth
        style={{ marginTop: '5%' }}
        label="Assign Marks"
        placeholder="Enter marks"
        name="assign"
        value={assignMark}
        margin="dense"
        onChange={(e) => setMark(e.target.value)}
      />
      {/* TODO: when this functionality is implemented on backend then we have to do this changes */}
      {/* {assignMark && (
        <div style={{ textAlign: 'center', marginTop: 15 }}>
          {!isMarked && (
            <Button variant="contained" onClick={() => setMarked(true)}>
              <TickIcon color="white" style={{ marginRight: 10 }} /> MARK CLASS TEST AS DONE
            </Button>
          )}
          {isMarked && (
            <>
              <Typography style={{ color: 'green' }}>
                <TickIcon color="green" style={{ marginRight: 10 }} width={15} height={15} /> MARK
                CLASS TEST AS DONE
              </Typography>

              <Button variant="outlined" style={{ marginTop: 20 }}>
                GENERATE CERTIFICATE
              </Button>
            </>
          )}
        </div>
      )}
      <div style={{ marginTop: '30%' }}>
        <TextBoxWithSendButton
          placeHolder="Type private comments"
          sendText={(e) => console.log('Line----23 Teacher.StudentSolutionDetails.js', e)}
        />
      </div> */}
    </>
  );
}

StudentSolutionDetails.propTypes = {
  title: PropTypes.string,
  onBack: PropTypes.func,
  studentDetail: PropTypes.any
};
